module.exports = __webpack_public_path__ + "img/Crosselling.47540b58.png";